import { configureStore } from "@reduxjs/toolkit"

import menuSliceReducer from "app/homepage/menuSlice"
import { mainSlice } from "app/homepage/slice"

import { authorizationApi } from "pages/auth/slice"
import { bookingsApi } from "pages/bookings/slice"
import bookingsCalendarReducer from "pages/bookingsCalendar/slice"
import { categoriesApi } from "pages/categories/slice"
import { bookingHashApi } from "pages/clientConfirmation/bookingHashApi"
import { clientApi } from "pages/customers/customersHistorySlice"
import { dentalChartApi } from "pages/customers/dentalChartSlice"
import { mastersApi, photoApi } from "pages/masters/slice"
import { restaurantsHashApi } from "pages/restaurarantSmS/restaurantSlice"
import { salonOwnerHashApi } from "pages/salonsOwner/salonOwnerSlice"
import { servicesApi } from "pages/services/slice"
import { worktimeApi } from "pages/workTimeCalendar/slice"
import changePassSliceReducer from "../features/headerMenu/changePassSlice.ts"
import bookingSliceReducer from "../pages/bookings/bookingSlice.ts"
import { newBookingApi } from "../pages/bookings/newBookingApi"
import statusesSliceReducer from "../pages/bookings/statusesSlice.ts"
import categoriesSliceReducer from "../pages/categories/categoriesSlice.ts"
import { customersApi } from "../pages/customers/customersApi"
import customersSliceReducer from "../pages/customers/customersSlice.ts"
import { newFeedbackApi } from "../pages/feedback/feedbackApi"
import { financeApi } from "../pages/finance/financeApi.js"
import { analyzesApi } from "../pages/laboratory/analyzes/analyzesApi"
import EditFormSliceReducer from "../pages/laboratory/analyzes/formPage/editFormSlice"
import { templatesApi } from "../pages/laboratory/templates/templatesApi"
import profileReducer, { userProfileApi } from "../pages/profile/userProfileApi"
import { reviewsApi } from "../pages/reviews/ReviewsSlice.js"
import citiesSliceReducer from "../pages/settings/citiesSlice.ts"
import { settingsApi } from "../pages/settings/settingsApi"
import settingsSliceReducer from "../pages/settings/settingsSlice.ts"
import spheresSliceReducer from "../pages/settings/spheresSlice.ts"
import { subscriptionApi } from "../pages/subscription/subscriptionApi.js"
import { transactionApi } from "../pages/transaction/transactionApi.js"
import { rtkQueryErrorMiddleware } from "./errorHandler"
import StepSliceReducer from "./homepage/stepSlice"
import { counterpartiesApi } from "../pages/directories/counterparties/counterpartiesApi"
import { itemsApi } from "../pages/directories/items/itemsApi"
import { accountsApi } from "../pages/directories/accounts/accountsApi"
import { operationsApi } from "../pages/finance/operations/operationsApi"

const rootReducer = {
  settingsSliceReducer,
  spheresSliceReducer,
  citiesSliceReducer,
  bookingSliceReducer,
  categoriesSliceReducer,
  customersSliceReducer,
  statusesSliceReducer,
  changePassSliceReducer,
  bookingsCalendarReducer,
  profileReducer,
  StepSliceReducer,
  EditFormSliceReducer,
  menuSliceReducer,

  [authorizationApi.reducerPath]: authorizationApi.reducer,
  [clientApi.reducerPath]: clientApi.reducer,
  [dentalChartApi.reducerPath]: dentalChartApi.reducer,
  [categoriesApi.reducerPath]: categoriesApi.reducer,
  [templatesApi.reducerPath]: templatesApi.reducer,
  [salonOwnerHashApi.reducerPath]: salonOwnerHashApi.reducer,
  [bookingsApi.reducerPath]: bookingsApi.reducer,
  [servicesApi.reducerPath]: servicesApi.reducer,
  [mastersApi.reducerPath]: mastersApi.reducer,
  [photoApi.reducerPath]: photoApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [userProfileApi.reducerPath]: userProfileApi.reducer,
  [newFeedbackApi.reducerPath]: newFeedbackApi.reducer,
  [customersApi.reducerPath]: customersApi.reducer,
  [newBookingApi.reducerPath]: newBookingApi.reducer,
  [analyzesApi.reducerPath]: analyzesApi.reducer,
  [bookingHashApi.reducerPath]: bookingHashApi.reducer,
  [worktimeApi.reducerPath]: worktimeApi.reducer,
  [restaurantsHashApi.reducerPath]: restaurantsHashApi.reducer,
  [reviewsApi.reducerPath]: reviewsApi.reducer,
  [financeApi.reducerPath]: financeApi.reducer,
  [transactionApi.reducerPath]: transactionApi.reducer,
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  [counterpartiesApi.reducerPath]: counterpartiesApi.reducer,
  [itemsApi.reducerPath]: itemsApi.reducer,
  [accountsApi.reducerPath]: accountsApi.reducer,
  [operationsApi.reducerPath]: operationsApi.reducer,
  main: mainSlice.reducer,
  // bookingsCalendar: bookingsCalendarSlice.reducer,
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      authorizationApi.middleware,
      reviewsApi.middleware,
      servicesApi.middleware,
      clientApi.middleware,
      dentalChartApi.middleware,
      categoriesApi.middleware,
      bookingsApi.middleware,
      mastersApi.middleware,
      photoApi.middleware,
      settingsApi.middleware,
      userProfileApi.middleware,
      newFeedbackApi.middleware,
      templatesApi.middleware,
      customersApi.middleware,
      newBookingApi.middleware,
      analyzesApi.middleware,
      bookingHashApi.middleware,
      salonOwnerHashApi.middleware,
      restaurantsHashApi.middleware,
      transactionApi.middleware,
      financeApi.middleware,
      subscriptionApi.middleware,
      counterpartiesApi.middleware,
      itemsApi.middleware,
      accountsApi.middleware,
      operationsApi.middleware,
      rtkQueryErrorMiddleware
    ),
})